module.exports = __webpack_public_path__ + "img/usuario-duo.06a6d44b.svg";